import { Component, Input, OnInit } from '@angular/core';
import { tvdData } from '../../types/tvd-types';

@Component({
    selector: 'icon-delete',
    templateUrl: './icon-delete.component.html',
    styleUrls: ['./icon-delete.component.scss'],
    standalone: false
})
export class IconDeleteComponent implements OnInit {

  @Input() makingSelectionsState: boolean | undefined;
  @Input() leftPosition: string | undefined;
  @Input() topPosition: string | undefined;

  @Input() selectedItem:boolean |undefined = false;

  constructor() { }

  ngOnInit(): void {
  }


}
